import Page from "../../components/Page/Page";
import { Row, Col, Input, Form, Select, Modal } from "antd";
import { useState,useEffect } from "react";
import AccountBalanceDetail from "../../components/AccountBalance";
import Classes from "./index.module.css";
import Widget from "../../components/Widget";
import CircularProgress from "../../components/CircularProgress";
import { GetCustomers } from "../../API/customer";
import { GetWithExpiry } from "../../util/sessionManager";
const Search = Input.Search;
const infoModal = Modal.info;
const ErrorModal = Modal.error;


export default function AccountBalance() {
  const [customers, setCustomers] = useState(GetWithExpiry("customers")?GetWithExpiry("customers"):[]);
  const [displayedCustomers, setDisplayedCustomers] = useState(
    customers ? customers : []
  );
  const [customersLoading,setCustomersLoading] = useState(false);
  useEffect(() => {
    if (!customers.length) {
      setCustomersLoading(true);
      GetCustomers()
        .then((i) => {
          if (i.success) {
            setCustomers(GetWithExpiry("customers"));
            setDisplayedCustomers(GetWithExpiry("customers"));
          }
        })
        .finally(() => {
          setCustomersLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, [customers]);
  
  const onSearch = (value, _e, info) => {
    setDisplayedCustomers(
      customers.filter((i) => {
        if (
          i.name.toString().includes(value) ||
          i.id.toString().includes(value)
        ) {
          return i;
        }
      })
    );
  };
  return (
    <>
      <Row className={Classes.searchForm}>
        <Widget styleName={Classes.setSearchItem}>
          <Form.Item>
            <Search
              placeholder="جستوجو نام و کد"
              onSearch={onSearch}
              allowClear
              enterButton
            />
          </Form.Item>
          <Form.Item>
            <Select defaultValue={0}>
              <Select.Option value={0}>همه</Select.Option>
              <Select.Option value={1}>بدهکار</Select.Option>
              <Select.Option value={2}>بستانکار</Select.Option>
            </Select>
          </Form.Item>
        </Widget>
      </Row>
      <Row>
        {customersLoading && <CircularProgress/>}
        {displayedCustomers.map((i) => {
          return (
            <AccountBalanceDetail customer={i} />
          );
        })}
      </Row>
    </>
  );
}

